import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { DeviceViewModel } from 'services/device/domain/model/DeviceModel';

import { ModalDialogueCaptionModifier, ModalDialogueHeader } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogueSectionName } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSectionName';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonSecondary, ButtonSecondaryStatus } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { useLocation } from 'react-router-dom';

export interface DeviceDeleteFormProps {
	device: DeviceViewModel
	onDelete: () => void;
	onDismiss: () => void;
}

export const DeviceDeleteForm = (props: DeviceDeleteFormProps): JSX.Element => {
	const { device, onDelete, onDismiss } = props;

	const l10nContext = useContext(L10nContext);

	const location = useLocation();

	let modalMessage = {
		first: l10nContext.translate('view.device.modal.action.delete.message.first', 'Wollen Sie das Gerät'),
		last: l10nContext.translate('view.device.modal.action.delete.message.last', 'wirklich löschen?')
	};

	if (location.pathname.includes('/clearances/')) {
		modalMessage = {
			first: l10nContext.translate('view.clearances.modal.delete.message.first', 'Wollen Sie die Freimessung'),
			last: l10nContext.translate('view.clearances.modal.delete.message.last', 'wirklich löschen?')
		};
	}

	return (
		<>
			<ModalDialogueHeader
				captionText={l10nContext.translate('common.modal.captionAttention', 'Achtung')}
				captionIcon={IconIdentifier.ALERT}
				captionModifier={ModalDialogueCaptionModifier.SMALL_CAPTION}
			/>
			<ModalDialogueSection>
				<>
					{modalMessage.first} <b>{device.Name}</b> {modalMessage.last}
				</>
			</ModalDialogueSection>

			<ModalDialogueSection section={ModalDialogueSectionName.SECTION_FOOTER}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.button.abort', 'Abbrechen')}
							onClick={onDismiss}
						/>
					</ColumnLayoutSection>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.modal.deleteConfirm', 'Ja, löschen')}
							status={ButtonSecondaryStatus.ATTENTION}
							icon={IconIdentifier.TRASH}
							onClick={onDelete}
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</ModalDialogueSection>
		</>
	);
};
